import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-help",
  "use": "app-icon-help-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"#777\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-help\"><path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z\" /><path d=\"M7.2 9.4c0-.3.2-1 1-1.6l.2-.2c.6-.5.8-.7.9-1.2 0-.4-.1-.7-.3-.9-.2-.2-.5-.3-.9-.3-.6 0-1 .2-1.1.8v.6l-1.5.6c-.1-.3-.2-.9-.1-1.6.2-1 1-2 2.7-2 .9 0 1.6.3 2.1.8s.7 1.2.7 2c-.1 1.3-.9 1.9-1.5 2.4l-.2.2c-.2.1-.3.3-.4.4H7.2z\" /><circle cx=\"8\" cy=\"11.7\" r=\"1.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol